/* @ngInject */
function SharedController ($scope, $state, $location, $stateParams, RepositoryService) {
  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId

  const api = {
  }

  this.getApi = () => api

  function activate () {
  }

  activate()
}

export { SharedController }
